/**
 * Client-facing price strings. Amounts must stay in sync with `backend/routes/payments.js` (Razorpay).
 *
 * CRA (`react-scripts`): `REACT_APP_*` values are embedded at build time. Changing `.env` on a server
 * does not update the bundle until you rebuild the frontend. For runtime pricing from the server,
 * expose a small public API and fetch it on app load (not implemented here).
 *
 * Env (optional overrides):
 *   REACT_APP_PRICE_FULL_REPORT_RUPEES — premium PDF / full report (default 199)
 *   REACT_APP_PRICE_KUNDLI_QUESTION_RUPEES — Shastra AI one-question, after the free first question (default 21)
 *   REACT_APP_PRICE_KUNDLI_QUESTION_OLD_RUPEES — previous Shastra AI price, shown struck-through (default 51)
 *   REACT_APP_PRICE_DASHBOARD_RUPEES — dashboard unlock (default 149); drives upgrade delta in copy
 */
function rupeesFromEnv(key, fallback) {
  const raw = process.env[key];
  if (raw === undefined || raw === '') return fallback;
  const n = parseInt(String(raw).trim(), 10);
  return Number.isFinite(n) && n >= 0 ? n : fallback;
}

const FULL_REPORT_RUPEES = rupeesFromEnv('REACT_APP_PRICE_FULL_REPORT_RUPEES', 199);
const DASHBOARD_RUPEES = rupeesFromEnv('REACT_APP_PRICE_DASHBOARD_RUPEES', 149);
/** First Shastra AI question is free; every question after that is billed at this rate (was ₹51). */
const KUNDLI_QUESTION_RUPEES = rupeesFromEnv('REACT_APP_PRICE_KUNDLI_QUESTION_RUPEES', 21);
const KUNDLI_QUESTION_OLD_RUPEES = rupeesFromEnv('REACT_APP_PRICE_KUNDLI_QUESTION_OLD_RUPEES', 51);

/** Numeric full-report price (for “list vs offer” math in popups, etc.). */
export const FULL_REPORT_RUPEES_NUM = FULL_REPORT_RUPEES;

export const PRICE_FULL_REPORT = `₹${FULL_REPORT_RUPEES}`;
export const PRICE_DASHBOARD = `₹${DASHBOARD_RUPEES}`;
/** Amount due when upgrading from Dashboard unlock to Full Report. */
export const PRICE_UPGRADE_DELTA = `₹${Math.max(0, FULL_REPORT_RUPEES - DASHBOARD_RUPEES)}`;

/** @deprecated Use PRICE_UPGRADE_DELTA — kept for any string concat that expected this name */
export const UPGRADE_FRAMING = PRICE_UPGRADE_DELTA;

/** In-app Shastra AI one-question answer (Razorpay; amount enforced server-side). First question is free. */
export const PRICE_KUNDLI_QUESTION = `₹${KUNDLI_QUESTION_RUPEES}`;
/** Previous Shastra AI price — display struck-through next to {@link PRICE_KUNDLI_QUESTION} for the “price dropped” framing. */
export const PRICE_KUNDLI_QUESTION_OLD = `₹${KUNDLI_QUESTION_OLD_RUPEES}`;

export const COPY_149_EXCLUDES_ANSWER =
  'Does not include the premium PDF report — use Order premium PDF or Shastra AI (' + PRICE_KUNDLI_QUESTION + ') for Q&A';

export const COPY_UPGRADE_HEADLINE = `Pay ${PRICE_UPGRADE_DELTA} more to complete Full Report`;
export const COPY_CHECKOUT_NOTE = `Full Report value ${PRICE_FULL_REPORT} — you already paid ${PRICE_DASHBOARD} for Dashboard`;

/** Bullets for full-report checkout — premium PDF, distinct from in-app Shastra AI */
export const MICRO_FULL_REPORT = [
  'Full kundli analysis premium PDF report',
  'Detailed houses, planets & dasha breakdown',
  'Delivered within 24 hours to your email',
];

export const COPY_POST_REPORT_PAYMENT =
  'Your premium PDF report will be delivered within 24 hours';
